import EntityService from './EntityService'
import { Patient } from '@/store/model/definitions/User'

export default new EntityService<Patient>(
  process.env.VUE_APP_PATIENT_ENDPOINT ?? '',
  'patient'
)
